var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 212 151",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.2248 171.22c-0.59697 0-1.229 0-1.826-0.035l0.035107-1.751c13.204 0.385 26.407-3.608 39.295-11.874 10.359-6.655 20.543-16.078 30.235-27.987 16.54-20.35 26.091-41.156 26.197-41.366l0.0702-0.1401 0.1053-0.1051c0.9131-1.0158 1.791-2.1366 2.5284-3.2925l17.031-27.461c0.527-0.8057 0.668-1.7864 0.457-2.6621-0.211-0.8406-0.773-1.5762-1.51-1.9965-1.651-0.9807-3.687-0.4203-4.741 1.296l-7.761 12.645c-0.386 0.5254-0.983 0.9458-1.65 1.1209-0.7375 0.1751-1.4749 0.07-2.0368-0.3153-0.5267-0.3852-0.9481-0.9807-1.1237-1.6462-0.1756-0.7356-0.0702-1.4711 0.2809-2.0316l7.7256-12.329c0.035-0.2101 0.14-0.3852 0.281-0.5254l5.408-8.9668c0.527-0.8056 0.667-1.7863 0.456-2.662-0.21-0.8407-0.772-1.5762-1.51-1.9965-1.65-0.9808-3.687-0.4204-4.74 1.2959l-0.281 0.3853-10.781 17.303c-0.3862 0.5254-0.9832 0.9458-1.6504 1.1209s-1.3696 0.1051-1.8963-0.2102c-0.4214-0.1401-0.7023-0.4903-0.8077-0.6655-0.597-0.8056-0.6321-2.0315-0.1053-2.9422l11.062-17.864 3.441-5.5343c0.527-0.8056 0.668-1.7863 0.457-2.662-0.211-0.8406-0.773-1.5762-1.51-1.9965-1.651-0.9808-3.6874-0.4203-4.7409 1.296l-5.1621 8.3714c-0.0702 0.105-0.1756 0.3152-0.3511 0.4553l-9.0249 14.816c-0.3863 0.5254-0.9833 0.9457-1.6505 1.1209-0.6672 0.1751-1.3695 0.105-1.8963-0.2102-0.4214-0.1401-0.7023-0.4904-0.8077-0.6655-0.5969-0.8056-0.6321-2.0316-0.1053-2.9423l9.4463-15.342c0.3863-0.9458 0.4916-1.9265 0.2809-2.7672-0.2458-0.9807-0.8077-1.5762-1.2642-1.8564-1.6153-0.9457-3.617-0.3853-4.7056 1.296l-17.277 28.582c-0.6321 1.0508-1.826 1.5762-2.8795 1.261-1.1589-0.3153-1.9666-1.261-2.0017-2.3118l-1.4397-13.065 0.0351-0.035c-0.1054-0.7706-0.4214-1.4361-0.9833-2.0315-0.5969-0.5955-1.51-0.9458-2.3879-0.8757-1.9665 0.1401-3.5116 1.7864-3.5467 3.7128v0.0701c-0.0351 1.0508-0.5619 22.592-0.4214 29.738 0.1405 3.2225 0.9481 6.3749 2.4581 9.2821l0.1756 0.3853-0.1756 0.3853c-0.0351 0.0701-3.933 8.6516-11.483 17.828-6.9882 8.477-18.647 19.265-34.519 22.382l-0.35116-1.716c15.346-3.012 26.653-13.485 33.466-21.752 6.5317-7.9157 10.254-15.376 11.062-17.093-1.4749-3.0473-2.3177-6.2697-2.4582-9.6323-0.1404-6.7251 0.3512-28.091 0.4565-29.878 0-2.8371 2.2826-5.2189 5.1621-5.4641 1.4047-0.0701 2.8094 0.4203 3.7575 1.401 0.8779 0.9107 1.4046 1.9966 1.51 3.2575 0 0.035 0.0351 0.0701 0.0351 0.1051 0.0351 0.1401 0.0351 0.3152-0.0351 0.4553l1.3695 12.434c0 0.2802 0.3161 0.5955 0.7024 0.7006 0.2809 0.07 0.6672-0.1402 0.8779-0.4904l17.277-28.617c1.5802-2.522 4.7056-3.3276 7.1286-1.8915l0.0351 0.0351c0.9833 0.6655 1.6856 1.7163 2.0016 2.9072 0.3161 1.2259 0.1756 2.5919-0.3862 3.923l-0.0703 0.105-9.4814 15.377c-0.2107 0.3502-0.1404 0.8056 0 0.9807 0 0 0.0351 0.035 0.0351 0.0701h0.0352l0.1755 0.105c0.1405 0.1051 0.3512 0.1051 0.597 0.0701 0.2458-0.0701 0.4916-0.2102 0.6321-0.4203l9.1654-15.026 0.1404-0.1051c0.0351-0.07 0.1054-0.2101 0.2107-0.3152l5.0217-8.1262c1.5802-2.4869 4.7052-3.3275 7.1282-1.8564 1.159 0.6655 2.002 1.7864 2.353 3.0823 0.351 1.3311 0.106 2.8022-0.667 4.0281l-3.441 5.5342-11.062 17.864c-0.2107 0.3503-0.1405 0.8057 0 0.9808 0 0 0.0351 0.035 0.0351 0.07h0.0352l0.1755 0.1051c0.1405 0.1051 0.3512 0.1051 0.597 0.0701 0.2458-0.0701 0.4916-0.2102 0.6321-0.4203l10.781-17.268 0.245-0.3853c1.545-2.4519 4.671-3.2925 7.094-1.8214 1.159 0.6655 2.001 1.7864 2.353 3.0824 0.351 1.331 0.105 2.8021-0.668 4.028l-5.513 9.142v0.0701l-7.9362 12.68c-0.1053 0.1401-0.1053 0.3503-0.0702 0.5955 0.0703 0.2802 0.2458 0.4903 0.4214 0.6305 0.1405 0.105 0.3512 0.105 0.597 0.07 0.246-0.07 0.492-0.2102 0.632-0.4203l7.726-12.575c1.58-2.4869 4.705-3.3275 7.128-1.8564 1.159 0.6655 2.002 1.7863 2.353 3.0823 0.351 1.3311 0.105 2.8022-0.667 4.0281l-16.926 27.461c-0.8079 1.1909-1.6858 2.3468-2.6339 3.3976-0.8077 1.7864-10.324 21.927-26.337 41.612-9.8326 12.049-20.122 21.612-30.657 28.372-12.607 8.091-25.565 12.189-38.487 12.189z",
    fill: "url(#h)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m221 185.83s-52.464 34.151-88.247-3.748c-35.784-37.898-48.917-56.182-48.917-56.182-1.1238-0.876-2.1772-1.822-3.1605-2.908l-21.421-24.238c-0.8428-0.9107-1.194-2.1016-1.1238-3.1875 0.0703-1.0858 0.6321-2.1366 1.4749-2.8371 1.7909-1.5412 4.4598-1.296 6.1103 0.5604l9.7623 11.138c0.6321 0.666 1.8612 0.806 2.5284 0.175 0.6672-0.63 0.8076-1.856 0.1756-2.522l-9.8326-10.998c-0.0702-0.2102-0.0702-0.2102-0.1756-0.2802l-6.953-8.0211c-0.8428-0.9107-1.194-2.1016-1.1237-3.1874 0.0702-1.0859 0.632-2.1367 1.4748-2.8372 1.791-1.5412 4.4598-1.296 6.1103 0.5604l0.316 0.3153 13.52 15.237c0.6321 0.6655 1.8611 0.8056 2.5284 0.1751 0.2107-0.0701 0.316-0.3152 0.3863-0.4553 0.2809-0.5254 0.2107-1.3661-0.281-1.9615l-13.906-15.762-4.3193-4.8687c-0.8428-0.9107-1.194-2.1016-1.1238-3.1874 0.0703-1.0858 0.6321-2.1366 1.4749-2.8372 1.7909-1.5411 4.4598-1.2959 6.1103 0.5605l6.3911 7.2505c0.1405 0.0701 0.1756 0.2802 0.3161 0.3152l0.1404 0.0701 11.483 13.17c0.6321 0.6655 1.8611 0.8056 2.5283 0.1752 0.2107-0.0701 0.3161-0.3153 0.3863-0.4554 0.281-0.5254 0.2107-1.366-0.2809-1.9615l-11.904-13.59c-0.6321-0.9808-1.0184-2.1717-0.9131-3.2575 0.0703-1.0858 0.5619-1.9965 1.2291-2.627 1.7909-1.5412 4.4598-1.296 6.1102 0.5604l21.842 25.289c0.527 0.5954 1.335 0.8756 2.002 0.5604s1.194-1.0158 1.089-1.7163l-0.738-12.68c-0.14-0.07-0.07-0.2101-0.07-0.2101-0.105-1.0508 0.105-2.0666 0.773-3.0473 0.667-0.9458 1.791-1.5412 2.809-1.6463 2.423-0.2102 4.67 1.4361 5.057 3.7829 0.07 0.2101 4.354 22.067 5.443 29.352 0.421 3.397 0.105 6.76-0.878 9.947 0 0 11.658 27.426 37.083 42.593 25.424 15.166 44.176-17.198 44.176-17.198",
    fill: "url(#g)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m124.68 61.549c0-0.1401 0-0.2452 0.035-0.3853 0.176-0.6655 0.843-1.0508 1.51-0.9107l15.838 3.853c0.667 0.1751 1.053 0.8406 0.913 1.5061-0.176 0.6655-0.843 1.0508-1.51 0.9107l-15.838-3.8529c-0.526-0.1401-0.913-0.5955-0.948-1.1209z",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m124.6 38.918c-0.105-0.0701-0.211-0.1401-0.281-0.2452-0.421-0.5254-0.316-1.331 0.211-1.7163l12.853-9.9826c0.526-0.4203 1.334-0.3152 1.72 0.2102 0.422 0.5254 0.316 1.331-0.21 1.7163l-12.853 9.9826c-0.421 0.3502-1.018 0.3502-1.44 0.035z",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m106.28 17.839c-0.105-0.035-0.246-0.0701-0.351-0.1401-0.562-0.3853-0.738-1.1209-0.386-1.7163l8.814-13.66c0.386-0.56043 1.123-0.73556 1.72-0.3853 0.562 0.3853 0.738 1.1209 0.387 1.7163l-8.814 13.66c-0.317 0.4553-0.878 0.6305-1.37 0.5254z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m58.025 26.063c-0.0703 0.1051-0.1405 0.2102-0.2459 0.2802-0.5267 0.4554-1.2993 0.3853-1.7558-0.1401l-10.605-12.294c-0.4565-0.5254-0.3862-1.2959 0.1405-1.7513 0.5268-0.4553 1.2993-0.3853 1.7558 0.1401l10.64 12.329c0.3161 0.3853 0.3512 0.9808 0.0703 1.4361z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m42.538 42.318c0 0.1401-0.0352 0.2452-0.0703 0.3853-0.2458 0.6305-0.9833 0.9457-1.6153 0.7006l-15.135-6.0246c-0.6321-0.2452-0.9481-0.9808-0.7023-1.6113 0.2458-0.6304 0.9832-0.9457 1.6153-0.7005l15.135 6.0246c0.5267 0.1751 0.8077 0.7005 0.7726 1.2259z",
    fill: "url(#b)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m80.744 17.976c-0.1053 0.0701-0.2107 0.1051-0.3511 0.1402-0.6672 0.1751-1.3345-0.2102-1.51-0.8757l-4.1789-15.692c-0.1756-0.66551 0.2107-1.331 0.8779-1.5061 0.6672-0.17513 1.3344 0.21016 1.51 0.87567l4.1789 15.692c0.1756 0.5604-0.0703 1.0858-0.5268 1.366z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m65.329 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0017BF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m65.365 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#001AC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m65.365 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#011DC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m65.4 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0120C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m65.4 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0223C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m65.435 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0226C2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m65.435 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0229C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m65.47 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#032CC3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m65.47 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#032FC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m65.504 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0332C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m65.504 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0435C5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m65.541 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0437C5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m65.574 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#043AC6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m65.574 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#053DC6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m65.611 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0540C7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m65.611 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0542C7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m65.644 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0645C8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m65.644 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0648C8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m65.68 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#064AC9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m65.68 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#074DC9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m65.716 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#074FCA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m65.716 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0752CA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m65.751 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0854CB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m65.751 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0857CB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m65.787 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0859CB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m65.821 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#095CCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m65.821 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#095ECC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m65.856 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0960CD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m65.856 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0963CD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m65.892 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A65CE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m65.892 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A67CE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m65.925 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A69CF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m65.925 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B6BCF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m65.961 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0B6ECF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m65.961 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0B70D0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m65.997 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B72D0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m66.031 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0C74D1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m66.031 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0C76D1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m66.066 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C78D1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m66.066 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C7AD2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m66.102 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D7CD2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m66.102 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D7ED2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m66.137 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D80D3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m66.137 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D82D3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m66.172 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E84D4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m66.172 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E86D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m66.206 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E88D4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m66.242 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E89D5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m66.242 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0F8BD5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m66.277 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0F8DD5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m66.277 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0F8FD6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m66.312 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0F90D6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m66.312 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0F92D6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m66.348 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1094D7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m66.348 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1095D7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m66.384 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1097D7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m66.384 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1099D7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m66.418 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#109AD8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m66.453 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#119CD8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m66.453 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#119DD8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m66.488 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#119FD9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m66.488 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#11A0D9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m66.524 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#11A2D9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m66.524 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#12A3D9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m66.56 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#12A5DA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m66.56 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#12A6DA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m66.593 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#12A8DA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m66.593 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#12A9DB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m66.629 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#13AADB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m66.665 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13ACDB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m66.665 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13ADDB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m66.698 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13AEDC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m66.698 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13B0DC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m66.734 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13B1DC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m66.734 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13B2DC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m66.769 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B3DC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m66.769 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B4DD"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m66.803 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B6DD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m66.803 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B7DD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m66.84 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B8DD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m66.874 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#14B9DE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m66.874 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#14BADE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m66.91 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BBDE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m66.91 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BCDE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m66.944 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BDDE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m66.944 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BEDF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m66.979 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BFDF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m66.979 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15C0DF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m67.016 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15C1DF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m67.016 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C2DF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m67.049 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#16C3DF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m67.085 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C4E0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m67.085 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C5E0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m67.121 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C6E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m67.121 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C7E0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m67.155 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C8E0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m67.155 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C9E0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m67.19 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C9E1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m67.19 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CAE1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m67.225 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CBE1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m67.225 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CCE1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m67.261 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CCE1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m67.297 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17CDE1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m67.297 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17CEE1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m67.33 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CFE2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m67.33 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CFE2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m67.366 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17D0E2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m67.366 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17D1E2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m67.402 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D1E2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m67.402 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D2E2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m67.437 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D3E2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m67.437 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D3E2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m67.473 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D4E3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m67.506 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D4E3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m67.506 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D5E3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m67.542 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D6E3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m67.542 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D6E3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m67.577 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D7E3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m67.577 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D7E3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m67.611 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D8E3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m67.611 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D8E3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m67.647 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D9E4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m67.647 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D9E4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m67.683 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18DAE4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m67.718 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DAE4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m67.718 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DBE4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m67.752 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DBE4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m67.752 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DBE4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m67.787 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DCE4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m67.787 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DCE4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m67.823 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DDE4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m67.823 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DDE4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m67.858 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DDE4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m67.858 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DEE4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m67.893 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DEE5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m67.927 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DEE5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m67.927 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DFE5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m67.962 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DFE5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m67.962 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DFE5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m67.998 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m67.998 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m68.034 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m68.034 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m68.068 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m68.068 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m68.103 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m68.139 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m68.139 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m68.174 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m68.174 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE2E5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m68.208 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE2E5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m68.208 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m68.243 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m68.243 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m68.279 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE3E5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m68.279 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE3E5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m68.315 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE3E6"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m68.35 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m68.35 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m68.384 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m68.384 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m68.42 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m68.42 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m68.455 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m68.455 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m68.491 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m68.491 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m68.524 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m68.56 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m68.56 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m68.596 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m68.596 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m68.63 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m68.63 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m68.666 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m68.666 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m68.702 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m68.702 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m68.736 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m68.771 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m68.771 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m68.806 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m68.806 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m68.842 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m68.842 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m68.875 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m68.875 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m68.911 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m68.911 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m68.947 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m68.98 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m68.98 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m69.016 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m69.016 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m69.052 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m69.052 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m69.087 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m69.087 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m69.122 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m69.122 28.717h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m69.156 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m69.192 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m69.192 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m69.228 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "m69.228 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "m69.261 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m69.261 28.717h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m129.94 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0017BF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m129.98 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#001AC0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m129.98 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#011DC0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m130.02 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0120C1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m130.02 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0223C1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m130.05 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0226C2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "m130.05 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0229C2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "m130.08 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#032CC3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m130.08 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#032FC4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "m130.12 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0332C4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m130.12 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0435C5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m130.15 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0437C5"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "m130.19 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#043AC6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m130.19 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#053DC6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m130.22 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0540C7"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "m130.22 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0542C7"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m130.26 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0645C8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m130.26 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0648C8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m130.29 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#064AC9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m130.29 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#074DC9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m130.33 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#074FCA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m130.33 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0752CA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m130.36 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0854CB"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m130.36 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0857CB"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m130.4 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0859CB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m130.44 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#095CCC"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m130.44 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#095ECC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m130.47 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0960CD"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m130.47 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0963CD"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m130.5 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0A65CE"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m130.5 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0A67CE"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m130.54 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0A69CF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m130.54 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0B6BCF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "m130.58 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0B6ECF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m130.58 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0B70D0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m130.61 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0B72D0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m130.64 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0C74D1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m130.64 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0C76D1"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m130.68 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0C78D1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "m130.68 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0C7AD2"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m130.72 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0D7CD2"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m130.72 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0D7ED2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m130.75 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0D80D3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m130.75 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0D82D3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m130.78 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0E84D4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m130.78 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0E86D4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m130.82 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0E88D4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m130.86 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0E89D5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m130.86 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8BD5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m130.89 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8DD5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m130.89 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8FD6"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m130.93 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0F90D6"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m130.93 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#0F92D6"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "m130.96 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1094D7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m130.96 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1095D7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m131 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1097D7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m131 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1099D7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m131.03 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#109AD8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m131.07 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#119CD8"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m131.07 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#119DD8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "m131.1 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#119FD9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "m131.1 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#11A0D9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m131.14 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#11A2D9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m131.14 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#12A3D9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m131.17 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#12A5DA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "m131.17 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#12A6DA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m131.21 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#12A8DA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m131.21 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#12A9DB"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "m131.24 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13AADB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "m131.28 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13ACDB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m131.28 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13ADDB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "m131.31 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13AEDC"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m131.31 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13B0DC"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "m131.35 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13B1DC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "m131.35 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#13B2DC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "m131.38 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B3DC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m131.38 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B4DD"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m131.42 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B6DD"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m131.42 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B7DD"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "m131.45 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B8DD"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m131.49 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14B9DE"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "m131.49 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#14BADE"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m131.52 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15BBDE"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "m131.52 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15BCDE"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m131.56 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15BDDE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m131.56 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15BEDF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "m131.59 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15BFDF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m131.59 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15C0DF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "m131.63 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#15C1DF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "m131.63 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C2DF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m131.66 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C3DF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m131.7 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#16C4E0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "m131.7 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#16C5E0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "m131.73 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C6E0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m131.73 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C7E0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "m131.77 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C8E0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "m131.77 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C9E0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m131.8 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#16C9E1"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m131.8 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17CAE1"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m131.84 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#17CBE1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m131.84 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#17CCE1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m131.88 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#17CCE1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m131.91 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17CDE1"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m131.91 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17CEE1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "m131.94 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17CFE2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "m131.94 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17CFE2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "m131.98 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17D0E2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m131.98 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17D1E2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m132.01 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17D1E2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "m132.01 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#17D2E2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m132.05 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D3E2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m132.05 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D3E2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "m132.09 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D4E3"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m132.12 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D4E3"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "m132.12 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D5E3"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m132.16 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D6E3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m132.16 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D6E3"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "m132.19 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D7E3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m132.19 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D7E3"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m132.22 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D8E3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m132.22 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D8E3"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m132.26 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D9E4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m132.26 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18D9E4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m132.3 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#18DAE4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m132.33 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DAE4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "m132.33 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m132.37 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m132.37 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m132.4 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DCE4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m132.4 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DCE4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m132.44 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m132.44 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m132.47 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m132.47 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m132.51 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m132.54 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m132.54 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m132.58 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m132.58 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m132.61 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E0E5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m132.61 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E0E5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m132.65 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E0E5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m132.65 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m132.68 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m132.68 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m132.72 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m132.75 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m132.75 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "m132.79 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "m132.79 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE2E5"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m132.82 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE2E5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m132.82 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m132.86 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m132.86 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m132.89 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m132.89 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m132.93 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E6"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m132.96 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE4E6"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m132.96 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE4E6"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m133 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m133 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m133.03 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m133.03 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m133.07 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m133.07 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m133.1 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m133.1 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m133.14 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "m133.17 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "m133.17 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "m133.21 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m133.21 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m133.24 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m133.24 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m133.28 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "m133.28 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "m133.31 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "m133.31 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "m133.35 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m133.38 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "m133.38 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m133.42 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m133.42 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "m133.46 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "m133.46 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "m133.49 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE6E6"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "m133.49 82.678h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE6E6"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "m133.52 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m133.52 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m133.56 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "m133.59 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "m133.59 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "m133.63 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "m133.63 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "m133.67 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "m133.67 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "m133.7 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m133.7 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m133.74 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "m133.74 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "m133.77 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "m133.81 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "m133.81 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m133.84 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "m133.84 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "m133.88 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m133.88 82.678h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m121.52 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0017BF"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "m121.55 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#001AC0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "m121.55 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#011DC0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m121.59 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0120C1"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "m121.59 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0223C1"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "m121.62 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0226C2"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "m121.62 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0229C2"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m121.66 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#032CC3"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "m121.66 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#032FC4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "m121.69 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0332C4"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "m121.69 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0435C5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m121.73 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0437C5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "m121.76 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#043AC6"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m121.76 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#053DC6"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "m121.8 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0540C7"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m121.8 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0542C7"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "m121.83 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0645C8"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "m121.83 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0648C8"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "m121.87 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#064AC9"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "m121.87 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#074DC9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "m121.9 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#074FCA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "m121.9 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0752CA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "m121.94 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#0854CB"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "m121.94 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#0857CB"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "m121.97 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0859CB"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "m122.01 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#095CCC"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "m122.01 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#095ECC"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "m122.04 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0960CD"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "m122.04 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0963CD"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "m122.08 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0A65CE"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "m122.08 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0A67CE"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "m122.11 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0A69CF"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "m122.11 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0B6BCF"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "m122.15 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0B6ECF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "m122.15 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0B70D0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "m122.18 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0B72D0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "m122.22 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0C74D1"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "m122.22 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0C76D1"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "m122.25 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0C78D1"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "m122.25 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0C7AD2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "m122.29 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0D7CD2"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "m122.29 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0D7ED2"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "m122.32 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0D80D3"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "m122.32 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0D82D3"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "m122.36 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0E84D4"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "m122.36 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0E86D4"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "m122.39 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0E88D4"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "m122.43 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0E89D5"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "m122.43 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8BD5"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "m122.46 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8DD5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "m122.46 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0F8FD6"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "m122.5 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0F90D6"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "m122.5 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#0F92D6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "m122.53 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1094D7"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "m122.53 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1095D7"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "m122.57 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#1097D7"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "m122.57 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#1099D7"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "m122.6 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#109AD8"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "m122.64 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#119CD8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "m122.64 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#119DD8"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "m122.68 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#119FD9"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "m122.68 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#11A0D9"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "m122.71 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#11A2D9"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "m122.71 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#12A3D9"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "m122.75 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#12A5DA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "m122.75 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#12A6DA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m122.78 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#12A8DA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m122.78 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#12A9DB"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m122.82 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13AADB"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "m122.85 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13ACDB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m122.85 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13ADDB"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "m122.88 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13AEDC"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "m122.88 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13B0DC"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "m122.92 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13B1DC"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m122.92 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#13B2DC"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m122.96 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B3DC"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m122.96 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B4DD"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "m122.99 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B6DD"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m122.99 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B7DD"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "m123.02 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B8DD"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m123.06 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14B9DE"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "m123.06 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#14BADE"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "m123.1 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15BBDE"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "m123.1 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15BCDE"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "m123.13 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15BDDE"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "m123.13 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15BEDF"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "m123.16 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15BFDF"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "m123.16 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15C0DF"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "m123.2 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#15C1DF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "m123.2 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C2DF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "m123.24 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C3DF"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "m123.27 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C4E0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "m123.27 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C5E0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m123.31 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#16C6E0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "m123.31 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#16C7E0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "m123.34 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C8E0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "m123.34 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C9E0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "m123.38 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#16C9E1"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "m123.38 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CAE1"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "m123.41 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CBE1"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "m123.41 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CCE1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "m123.45 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CCE1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "m123.48 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CDE1"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "m123.48 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CEE1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "m123.52 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CFE2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "m123.52 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17CFE2"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "m123.55 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17D0E2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "m123.55 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17D1E2"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "m123.59 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17D1E2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "m123.59 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#17D2E2"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "m123.62 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D3E2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "m123.62 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D3E2"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "m123.66 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D4E3"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "m123.69 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D4E3"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "m123.69 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D5E3"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "m123.73 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D6E3"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m123.73 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D6E3"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m123.76 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D7E3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "m123.76 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D7E3"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m123.8 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D8E3"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "m123.8 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D8E3"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m123.83 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D9E4"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "m123.83 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18D9E4"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m123.87 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#18DAE4"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "m123.9 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DAE4"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m123.9 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m123.94 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "m123.94 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m123.97 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DCE4"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "m123.97 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DCE4"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m124.01 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "m124.01 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "m124.04 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DDE4"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "m124.04 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "m124.08 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE5"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "m124.11 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DEE5"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "m124.11 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "m124.15 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "m124.15 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19DFE5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "m124.18 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E0E5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "m124.18 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E0E5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "m124.22 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#19E0E5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "m124.22 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#19E1E5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "m124.26 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "m124.26 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "m124.29 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E1E5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "m124.32 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "m124.32 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "m124.36 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#19E2E5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "m124.36 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE2E5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "m124.39 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE2E5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "m124.39 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "m124.43 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "m124.43 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "m124.46 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "m124.46 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "m124.5 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E6"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "m124.54 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "m124.54 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "m124.57 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "m124.57 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "m124.61 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "m124.61 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "m124.64 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE4E6"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "m124.64 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "m124.68 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "m124.68 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "m124.71 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "m124.75 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "m124.75 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "m124.78 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "m124.78 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "m124.82 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "m124.82 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "m124.85 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "m124.85 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE5E6"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "m124.89 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE5E6"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "m124.89 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE6E6"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "m124.92 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "m124.96 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "m124.96 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "m124.99 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "m124.99 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "m125.03 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "m125.03 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "m125.06 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "m125.06 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "m125.13 17.512h-0.036v3.958h0.036v-3.958z",
    fill: "#1AE6E6"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "m125.17 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "m125.17 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "m125.2 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "m125.2 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "m125.24 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "m125.24 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "m125.27 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "m125.27 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "m125.31 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "m125.31 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "m125.34 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "m125.38 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "m125.38 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "m125.41 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "m125.41 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "m125.45 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "m125.45 17.512h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE6E6"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "m41.802 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0017BF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "m41.839 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#001AC0"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "m41.839 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#011DC0"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "m41.874 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0120C1"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "m41.874 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0223C1"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "m41.908 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0226C2"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "m41.908 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0229C2"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m41.943 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#032CC3"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "m41.943 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#032FC4"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "m41.979 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0332C4"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "m41.979 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0435C5"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "m42.015 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0437C5"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "m42.047 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#043AC6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "m42.047 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#053DC6"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "m42.084 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0540C7"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "m42.084 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0542C7"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "m42.117 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0645C8"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "m42.117 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0648C8"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "m42.153 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#064AC9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "m42.153 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#074DC9"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "m42.189 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#074FCA"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "m42.189 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0752CA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "m42.223 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0854CB"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "m42.223 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0857CB"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "m42.259 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0859CB"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "m42.294 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#095CCC"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "m42.294 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#095ECC"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "m42.329 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#0960CD"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "m42.329 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#0963CD"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "m42.365 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A65CE"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "m42.365 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A67CE"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "m42.398 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0A69CF"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "m42.398 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B6BCF"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "m42.434 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B6ECF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "m42.434 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B70D0"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "m42.47 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0B72D0"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "m42.503 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C74D1"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "m42.503 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C76D1"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "m42.539 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C78D1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "m42.539 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0C7AD2"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "m42.575 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D7CD2"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "m42.575 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D7ED2"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "m42.61 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D80D3"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "m42.61 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0D82D3"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "m42.645 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E84D4"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "m42.645 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E86D4"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "m42.679 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0E88D4"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "m42.715 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0E89D5"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "m42.715 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0F8BD5"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "m42.75 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0F8DD5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "m42.75 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#0F8FD6"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "m42.784 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0F90D6"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "m42.784 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#0F92D6"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "m42.82 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1094D7"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "m42.82 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1095D7"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "m42.856 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1097D7"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "m42.856 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1099D7"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "m42.891 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#109AD8"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "m42.926 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#119CD8"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "m42.926 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#119DD8"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "m42.96 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#119FD9"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "m42.96 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#11A0D9"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "m42.996 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#11A2D9"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "m42.996 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#12A3D9"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "m43.032 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#12A5DA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "m43.032 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#12A6DA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "m43.066 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#12A8DA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "m43.066 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#12A9DB"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "m43.102 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13AADB"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "m43.138 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13ACDB"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "m43.138 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13ADDB"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "m43.171 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#13AEDC"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "m43.171 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#13B0DC"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "m43.207 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13B1DC"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "m43.207 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#13B2DC"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "m43.242 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B3DC"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "m43.242 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B4DD"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "m43.276 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B6DD"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "m43.276 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B7DD"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "m43.312 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#14B8DD"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "m43.347 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#14B9DE"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "m43.347 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#14BADE"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "m43.383 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#15BBDE"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "m43.383 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#15BCDE"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "m43.418 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#15BDDE"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "m43.418 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#15BEDF"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "m43.452 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15BFDF"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "m43.452 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15C0DF"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "m43.488 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#15C1DF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "m43.488 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C2DF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "m43.522 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C3DF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "m43.558 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C4E0"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "m43.558 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C5E0"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "m43.592 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C6E0"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "m43.592 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C7E0"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "m43.628 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C8E0"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "m43.628 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C9E0"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "m43.663 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#16C9E1"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "m43.663 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CAE1"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "m43.698 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CBE1"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "m43.698 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CCE1"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "m43.734 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CCE1"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "m43.769 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CDE1"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "m43.769 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17CEE1"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "m43.803 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17CFE2"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "m43.803 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#17CFE2"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "m43.839 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D0E2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "m43.839 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D1E2"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "m43.874 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D1E2"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "m43.874 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#17D2E2"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "m43.909 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D3E2"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "m43.909 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D3E2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "m43.946 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D4E3"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "m43.979 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D4E3"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "m43.979 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D5E3"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "m44.015 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D6E3"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "m44.015 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D6E3"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "m44.048 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D7E3"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "m44.048 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#18D7E3"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "m44.084 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D8E3"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "m44.084 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D8E3"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "m44.12 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D9E4"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "m44.12 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18D9E4"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "m44.155 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#18DAE4"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "m44.191 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#19DAE4"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "m44.191 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#19DBE4"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "m44.225 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DBE4"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "m44.225 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DBE4"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "m44.26 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DCE4"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "m44.26 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DCE4"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "m44.296 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DDE4"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "m44.296 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19DDE4"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "m44.329 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DDE4"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "m44.329 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DEE4"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "m44.365 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DEE5"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "m44.401 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DEE5"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "m44.401 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DFE5"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "m44.435 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DFE5"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "m44.435 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19DFE5"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "m44.471 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "m44.471 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "m44.507 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E0E5"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "m44.507 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "m44.541 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "m44.541 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E1E5"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "m44.576 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#19E1E5"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "m44.611 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "m44.611 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "m44.647 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#19E2E5"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "m44.647 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE2E5"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "m44.681 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE2E5"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "m44.681 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "m44.716 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "m44.716 60.598h-0.035v3.958h0.035v-3.958z",
    fill: "#1AE3E5"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "m44.752 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "m44.752 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "m44.788 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE3E6"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "m44.822 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "m44.822 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "m44.857 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "m44.857 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "m44.892 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "m44.892 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "m44.928 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE4E6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "m44.928 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "m44.964 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE5E6"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "m44.964 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE5E6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "m44.997 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "m45.033 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "m45.033 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "m45.069 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE5E6"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "m45.069 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE5E6"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "m45.103 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "m45.103 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "m45.138 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "m45.138 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE5E6"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "m45.173 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE5E6"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "m45.173 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "m45.209 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "m45.244 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "m45.244 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "m45.279 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "m45.279 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "m45.314 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "m45.314 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "m45.348 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "m45.348 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "m45.384 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "m45.384 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "m45.42 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "m45.453 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "m45.453 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "m45.489 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "m45.489 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "m45.525 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "m45.525 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "m45.56 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "m45.56 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "m45.594 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "m45.594 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "m45.629 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "m45.665 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "m45.665 60.598h-0.0352v3.958h0.0352v-3.958z",
    fill: "#1AE6E6"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "m45.701 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "m45.701 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "m45.734 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "m45.734 60.598h-0.0351v3.958h0.0351v-3.958z",
    fill: "#1AE6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 118.2,
    x2: 0.38694,
    y1: 97.159,
    y2: 97.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074BC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 65.839,
    x2: 209.24,
    y1: 141.41,
    y2: 116.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074BC9",
    stopOpacity: 0.1,
    offset: 0.9968
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 134.74,
    x2: 139.72,
    y1: 56.143,
    y2: 67.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 126.79,
    x2: 138.79,
    y1: 27.677,
    y2: 30.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 104.5,
    x2: 116.86,
    y1: 6.4776,
    y2: 5.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 46.752,
    x2: 49.26,
    y1: 24.489,
    y2: 12.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.847,
    x2: 28.484,
    y1: 46.242,
    y2: 34.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 71.096,
    x2: 78.633,
    y1: 11.72,
    y2: 1.8908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.3cc5cdd47cab5f8f0d8719b443523406.svg";
export { ForwardRef as ReactComponent };